import { render, staticRenderFns } from "./growupStudents.vue?vue&type=template&id=09e2c1aa&scoped=true&"
import script from "./growupStudents.vue?vue&type=script&lang=js&"
export * from "./growupStudents.vue?vue&type=script&lang=js&"
import style0 from "./growupStudents.vue?vue&type=style&index=0&id=09e2c1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2c1aa",
  null
  
)

export default component.exports